import InventoryIcon from "assets/images/inventory_icon.svg";
import ReconciliationIcon from "assets/images/reconciliation_icon.svg";
import MultistoreIcon from "assets/images/multistore_icon.svg";
import MobileIcon from "assets/images/mobile-icon.svg";
import ComplianceIcon from "assets/images/compliance_icon.svg";
import DashboardIcon from "assets/images/dashboard_icon.svg";

export default function FeaturesSection() {
  return (
    <section className="features-section">
      <div className="features-scroll-element"></div>
      <h2 className="features-title">
        Advanced Lottery Management System Features
      </h2>
      <div className="custom-container d-flex items-center width-100">
        <div className="features-grid">
          <div className="feature-card">
            <img
              className="feature-icon"
              src={InventoryIcon}
              alt="Lottery reconciliation software dashboard showing inventory tracking"
              loading="lazy"
            />
            <div>
              <h3>Lottery OCR Scanning Technology</h3>
              <p>
                Our advanced lottery OCR scanning technology uses AI-powered optical character recognition 
                to instantly digitize ticket counts, game numbers, and pack information from lottery reports 
                with 95%+ accuracy. This lottery tracking software eliminates manual data entry errors and supports 
                <a href="/smartcount-integration">SmartCount integration</a> for seamless data synchronization.
              </p>
            </div>
          </div>
          <div className="feature-card">
            <img
              className="feature-icon"
              src={ReconciliationIcon}
              alt="Scratch-off ticket inventory tracking software interface"
              loading="lazy"
            />
            <div>
              <h3>Lottery Inventory Management</h3>
              <p>
                Our comprehensive lottery inventory management system provides real-time tracking 
                of scratch-off tickets, instant ticket stock, and game inventory. This lottery management 
                solution prevents shrinkage and ensures accurate <a href="/lottery-reconciliation-software">lottery sales vs payout reconciliation</a> across all shifts.
              </p>
            </div>
          </div>
          <div className="feature-card">
            <img
              className="feature-icon"
              src={MultistoreIcon}
              alt="Convenience store lottery theft prevention dashboard"
              loading="lazy"
            />
            <div>
              <h3>Lottery Sales Tracking</h3>
              <p>
                Our lottery sales tracking system monitors sales by game, by shift, and by employee 
                with detailed analytics. This lottery tracking system provides real-time discrepancy 
                detection that flags missing tickets, unauthorized voids, and suspicious activity. Learn more about 
                <a href="/blog/automated-lottery-reconciliation-45-minutes-to-5-minutes">automated reconciliation that saves time</a>.
              </p>
            </div>
          </div>
          <div className="feature-card">
            <img
              className="feature-icon"
              src={MobileIcon}
              alt="C-store lottery management mobile interface"
              loading="lazy"
            />
            <div>
              <h3>Lottery Operations Software</h3>
              <p>
                Our lottery operations software streamlines lottery operations end-to-end with a 
                mobile-first design. Free mobile app for Android and iOS turns your phone into a 
                lottery assistant for scanning barcodes, checking inventory, and managing audits anywhere.
              </p>
            </div>
          </div>
          <div className="feature-card">
            <img
              className="feature-icon"
              src={ComplianceIcon}
              alt="Lottery compliance reporting software dashboard"
              loading="lazy"
            />
            <div>
              <h3>Lottery Reporting Software</h3>
              <p>
                Our lottery reporting software generates detailed sales reports, profit analysis, 
                and inventory tracking with real-time data from your POS and lottery systems. 
                This comprehensive reporting solution provides the insights you need for better decision-making.
              </p>
            </div>
          </div>
          <div className="feature-card">
            <img
              className="feature-icon"
              src={DashboardIcon}
              alt="California lottery compliance integration dashboard"
              loading="lazy"
            />
            <div>
              <h3>California Lottery Integration</h3>
              <p>
                Seamless integration with California Lottery's SmartCount
                system. Automatic data synchronization and batch processing for
                daily summaries.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
